<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <h1 class="display-2 font-weight-light mb-8">
      Olga Astorg & and her Art
    </h1>

    <v-responsive
      class="mx-auto subtitle-1 grey--text"
      max-width="550"
    >
      Je vous souhaite la bienvenue sur mon site, sur lequel vous trouverez une partie de mon travail.
    </v-responsive>
  </section>
</template>

<script>
  export default {
    name: 'Headline',
  }
</script>
